/* global google */
import React, { useState, useEffect, useCallback } from 'react';
import { AdvancedMarker, APIProvider, Map, useMapsLibrary, Marker, Pin, useMap, InfoWindow } from '@vis.gl/react-google-maps';
import markericonOver from "assets/img/maps/over.png";
import moment from "moment";
import { ClusteredMarkers as GatewaysClusteredMarkers } from './Gateways/ClusteredMarkers';
import { InfoWindowContent as GatewaysInfoWindowContent } from './Gateways/InfoWindowContent';
import { ClusteredMarkers as MetersClusteredMarkers } from './Meters/ClusteredMarkers';
import { InfoWindowContent as MetersInfoWindowContent } from './Meters/InfoWindowContent';

//import OverlappingMarkerSpiderfier from "overlapping-marker-spiderfier";
import "../style.css";

const mapstyle = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
        featureType: "administrative.locality",
        elementType: "labels.text.fill",
        stylers: [{ color: "#d59563" }],
    },
    {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#38414e" }],
    },
    {
        featureType: "road",
        elementType: "geometry.stroke",
        stylers: [{ color: "#212a37" }],
    },
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#746855" }],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#1f2835" }],
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "transit.station",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#17263c" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#515c6d" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.stroke",
        stylers: [{ visibility: 'off' }]
    }
];

export default function MapComponent(props) {
    const { markersraw, onMarkerClickCallback, activeSiteId, setActiveSiteId,
        overSiteId, selectedOption, filteredrows, setFilteredrows, bouncingdest, metersfilters } = props;

    const [geojsonmarkers, setGeojsonmarkers] = useState({ features: [] });
    const [numClusters, setNumClusters] = useState(0);
    const [bounds, setBounds] = useState();
    const [bouncingmarker, setBouncingmarker] = useState(null);

    const map = useMap();

    const [infowindowData, setInfowindowData] = useState(null);

    const handleInfoWindowClose = useCallback(
        () => setInfowindowData(null),
        [setInfowindowData]
    );

    useEffect(() => {
        if (bouncingdest) {
            let marker = <AdvancedMarker
                key={'bouncing001'}
                // className={'bounce'}
                position={bouncingdest}
                title={''}
                zIndex={9999}
            >
                <Pin
                    background={'#91c241'}
                    borderColor={'#91c241'}
                    glyphColor={'#91c241'}
                />
            </AdvancedMarker>
            setBouncingmarker(marker);
            console.log(bouncingdest);
        }
        else
            setBouncingmarker(null);

    }, [bouncingdest]);

    useEffect(() => {
        if (!map)
            return;
        var styledMapType = new google.maps.StyledMapType(mapstyle,
            { name: "Simple" });
        map.mapTypes.set("styled_map", styledMapType);
        map.setMapTypeId("styled_map");
        var boundsTmp = new google.maps.LatLngBounds();
        if (markersraw.length == 0) {
            boundsTmp.extend(new google.maps.LatLng(50.1, 2.4));
            boundsTmp.extend(new google.maps.LatLng(42.7, 2.4));
        }
        let geojsontmp = {};
        geojsontmp.features = [];
        console.log(markersraw);
        markersraw.map((mark, i) => {


            var status = 'unknown';
            if (mark.destination.lastconnection) {
                if (moment(mark.destination.lastconnection).isValid() && moment(mark.destination.lastconnection) < moment().add(-90, 'm'))
                    status = "ko";
                else if (moment(mark.destination.lastconnection).isValid())
                    status = "ok";
            }
            if (selectedOption === '10') {
                boundsTmp.extend(new google.maps.LatLng(mark.destination.location.lat, mark.destination.location.lng));
                let markergeojson = {
                    type: "Feature",
                    id: mark.destination.id,
                    geometry: {
                        type: "Point",
                        coordinates: [mark.destination.location.lng, mark.destination.location.lat]
                    },
                    properties: {
                        name: mark.destination.text,
                        status: status,
                        lastconnection: mark.destination.lastconnection,
                        description: mark.destination.description,
                        groupid: mark.destination.groupid,
                        otherparameters: mark.destination.otherparameters,

                    }
                }
                geojsontmp.features.push(markergeojson);
            }
            else if (selectedOption === 'meters') {
                if (metersfilters.length === 0 || metersfilters.includes(mark.destination.energy)) {
                    if (mark.destination.location.lat && mark.destination.location.lng) {
                        boundsTmp.extend(new google.maps.LatLng(mark.destination.location.lat, mark.destination.location.lng));
                        let markergeojson = {
                            type: "Feature",
                            id: mark.destination.id,
                            geometry: {
                                type: "Point",
                                coordinates: [mark.destination.location.lng, mark.destination.location.lat]
                            },
                            properties: {
                                name: mark.destination.text,
                                status: status,
                                lastconnection: '',
                                description: '',
                                groupid: mark.destination.groupid,
                                otherparameters: mark.destination.details,
                                energy: mark.destination.energy,
                            }
                        }
                        geojsontmp.features.push(markergeojson);
                    }

                }
            }
        })
        setGeojsonmarkers(geojsontmp);
        map.fitBounds(boundsTmp);
        setBounds(boundsTmp);

    }, [markersraw, map, metersfilters])


    const mapTypeControlOptions = {
        mapTypeIds: [
            "styled_map",
            google.maps.MapTypeId.SATELLITE,
        ]
    };

    console.log(geojsonmarkers);
    return (
        <Map
            defaultCenter={{ lat: 46.778476, lng: 2.392557 }}
            defaultZoom={10}
            mapId='888-777-666'
            className={'custom-marker-clustering-map'}
            mapTypeControlOptions={mapTypeControlOptions}
        >
            {bouncingmarker ? bouncingmarker : <></>}
            {selectedOption === '10' ? <>
                <GatewaysClusteredMarkers
                    geojson={geojsonmarkers}
                    setNumClusters={setNumClusters}
                    setInfowindowData={setInfowindowData}
                />
                {(infowindowData && infowindowData?.anchor?.content?.firstElementChild) && (
                    <InfoWindow
                        className={"bacsinfowindow"}
                        onCloseClick={handleInfoWindowClose}
                        anchor={infowindowData.anchor}
                        headerContent={<div class="bacsinfowindowtitle">{infowindowData?.features?.length === 1 ? infowindowData?.features[0]?.properties.name : "Groupe de passerelles"}</div>}>
                        <GatewaysInfoWindowContent features={infowindowData.features} />
                    </InfoWindow>
                )}</>

                : selectedOption === 'meters' ? <>
                    <MetersClusteredMarkers
                        geojson={geojsonmarkers}
                        setNumClusters={setNumClusters}
                        setInfowindowData={setInfowindowData}
                        filteredrows={filteredrows}
                        setFilteredrows={setFilteredrows}
                        overSiteId={overSiteId}
                        activeSiteId={activeSiteId}
                    />
                    {(infowindowData && infowindowData?.anchor?.content?.firstElementChild) && (
                        <InfoWindow
                            className={"bacsinfowindow"}
                            onCloseClick={handleInfoWindowClose}
                            anchor={infowindowData.anchor}
                            headerContent={<div class="bacsinfowindowtitle">{infowindowData?.features?.length === 1 ? infowindowData?.features[0]?.properties.name : "Groupe de compteurs"}</div>}>
                            <MetersInfoWindowContent features={infowindowData.features} setActiveSiteId={setActiveSiteId} />
                        </InfoWindow>
                    )}</> : <></>
            }

        </Map>


    );
}

